import { z } from 'zod';

import { reviewEventSchema } from '../review-event.ts';
export const reviewEventStreamPayloadSchema = z
  .object({ cursor: z.string().min(1), event: reviewEventSchema })
  .strict();
export type ReviewEventStreamPayload = z.infer<
  typeof reviewEventStreamPayloadSchema
>;
